/**
 * Thrown by the axios 401 interceptor when a session expires mid-flight.
 * Callers should treat this as a no-op: the user has already been redirected
 * to the LoggedOut screen and no toast should be shown.
 */
export class LoggedOutError extends Error {
  constructor() {
    super('Session expired — user has been logged out.');
    this.name = 'LoggedOutError';
  }
}
